import axios from 'axios'

axios.defaults.headers.common['Content-Type'] = 'application/json'

const isMultiLogin = process.env.REACT_APP_MULTI_LOGIN === 'true'

const appConfig = {
  layoutAndModuleWidth: '29em',
  subscriptionAgreementWidth: {
    layoutWidth: '48em',
    moduleWidth: '55em',
  },
  disableLoggingErrorService:
    process.env.NODE_ENV === 'development' ? true : false,
  isMultiLogin,
}

export default appConfig
